// import { format } from "date-fns";

export function formatDateToBackend(dateString: string) {
  if (!dateString || dateString === "") {
    return "";
  }

  if (dateString.includes("/")) {
    const [day, month, year] = dateString.split("/").map(Number);
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
      2,
      "0"
    )}`;
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    const parts = dateString.split("-");
    if (parts.length === 3) {
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const day = parseInt(parts[2], 10);
      return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
        2,
        "0"
      )}`;
    }
    return "";
  } 
  return _format(dateString);

  // return format(date, "yyyy-MM-dd");
}

export function _format( strDate: string)  {
  const date = new Date(strDate);

  const yyyy = date.getUTCFullYear();
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(date.getUTCDate()).padStart(2, '0');

  return  `${yyyy}-${mm}-${dd}`;
}